<template>
  <div class="school_course_item">
    <div
      class="cover"
      :style="{
        'background-image': `url(${cover})`,
      }"
    >
      <div v-if="data.cover.includes('cover_')">{{ data.name }}</div>
    </div>
    <p class="title">{{ data.name }}</p>

    <div class="status">
      <!-- <p class="status_1">公开课</p>
      <p class="status_3">已公开</p>
      <p class="status_4">自制课</p> -->
      <!-- <p class="status_5" v-if="data.status === 'UP'">未发布</p> -->
      <template v-if="data.status">
        <p class="status_2" v-if="data.status === 'UP'">已上架</p>
        <p class="status_5" v-if="data.status === 'CREATING'">草稿</p>
        <p class="status_4" v-if="data.status === 'DOWN'">已下架</p>
        <p class="status_1" v-if="data.status === 'OPEN'">已公开</p>
        <p class="status_3" v-if="data.status === 'APPLY_OPEN'">申请公开</p>
      </template>

      <template v-if="data.checkStatus">
        <p :class="currentCheckStatus[data.checkStatus][1]">{{ currentCheckStatus[data.checkStatus][0] }}</p>
      </template>
    </div>

    <div class="info">
      <div>
        <i class="el-icon-user-solid icon"></i>
        <!-- <img src="@/assets/images/cmp/userName_icon.png" alt="" /> -->
        <span>{{ data.teacherName || "--" }}</span>
      </div>
    </div>
    <el-dialog title="课程发布" :visible.sync="dialogVisible" width="350px" append-to-body>
      <div class="radio-item" v-for="(v, i) in courseTypeList" :key="i">
        <el-radio v-model="courseType" :label="v.name">{{ v.label }}</el-radio>
        <p>{{ v.content }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="bookUpAndDownStep2">确 定</el-button>
      </span>
    </el-dialog>

    <div class="school_course_item_hover" @click.stop="gotoCatalogue">
      <ul class="footer">
        <li>
          <i class="el-icon-s-home icon"></i>
          <!-- <img src="@/assets/images/cmp/userName_icon.png" alt="" /> -->
          <span>{{ data.gradeName }}{{ data.volumeName }}</span>
        </li>

        <li>
          <i class="el-icon-s-management icon"></i>
          <!-- <img src="@/assets/images/cmp/userName_icon.png" alt="" /> -->
          <span>{{ data.teacherName || "--" }}</span>
        </li>

        <!-- <li>
          <i class="el-icon-s-shop icon"></i>
          <span>{{ data.teacherName || "--" }}</span>
        </li> -->
      </ul>
    </div>
    <div class="operate">
      <i class="el-icon-s-grid icon"></i>
      <ul>
        <li @click.stop="gotoCatalogue">详情</li>
        <!-- <li v-if="downOrUpFlag" @click.stop="bookUpAndDownStep1">{{ data.status === "UP" ? "下架" : "发布" }}</li> -->
        <!-- <li v-if="downOrUpFlag" @click.stop="courseUpOrDownChange">{{ data.status === "UP" ? "下架" : "上架" }}</li> -->
        <!-- courseUpOrDown -->
        <li v-if="editCourseFlag" @click.stop="gotoEdit">编辑课程</li>
        <li v-if="copyCourseFlag" @click.stop="copy">复制课程</li>
        <li v-if="removeCourseBtnFlag" @click.stop="deleteCourse">
          删除课程
        </li>
        <li v-if="associateClassBtnFlag" @click="associateClassChange">关联上课班级</li>
      </ul>
    </div>
    <el-dialog title="关联班级" :visible.sync="associateClassFlag" width="30%">
      <el-checkbox-group v-model="bindClassCode">
        <el-checkbox v-for="(v, i) in classList" :label="v.id" :key="i">{{ v.gradeName }} - {{ v.name }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="associateClassFlag = false">取 消</el-button>
        <el-button type="primary" @click="bindClassCodeChange">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import utils from "@/assets/js/utils.js";
import publicUrl from "@/assets/js/interface";

export default {
  name: "cmp-course",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "0",
    },
    active: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    isPublic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      classList: [],
      bindClassCode: [],
      associateClassFlag: false,
      dialogVisible: false,
      courseType: "CLASS",
      courseTypeList: [
        { name: "CLASS", label: "班级可见", content: "发布后仅自己班级的学生可使用" },
        { name: "SCHOOL", label: "学校可见", content: "发布后全校师生均可查看使用" },
      ],
      // imgDict: {
      //   0: this.loadFile("res-0"),
      //   1: this.loadFile("res-1"),
      // },
    };
  },
  watch: {
    associateClassFlag(n) {
      if (!n) {
        this.bindClassCode = [];
        this.classList = [];
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      courseCoverList: (state) => state.courseCoverList,
      currentCheckStatus: (state) => state.currentCheckStatus,
    }),

    // 自制课
    // 教师：編輯 刪除 发布 =》 关联班级  下架
    // 学生：查看详情
    // 校管：編輯 刪除 发布 =》 关联班级  下架

    // 标准课
    // 编辑老师：編輯  提交审核
    // 审核编辑: 編輯  提交复审 驳回
    // 审核负责人: 編輯 刪除 终审 驳回 上架

    // 上架下架权限
    downOrUpFlag() {
      let roles = ["TEACHER", "TEACHER_RESEARCH","SCHOOL_MANAGER"];
      // let roles = this.data.type !== "PUBLIC" ? ["TEACHER, SCHOOL_MANAGER"] : ["FINAL_REDACT"];
      return roles.includes(this.userInfo.type);
    },
    // 删除课程(校管、老师、审核编辑有删除权限，并且只能删除自己创建的课程)
    removeCourseBtnFlag() {
      let flag = false;
      if (
        ["TEACHER", "TEACHER_RESEARCH","SCHOOL_MANAGER", "REDACT"].includes(this.userInfo.type) &&
        this.editable &&
        (this.data.status === "DOWN" || this.data.status === "CREATING") &&
        this.data.createUserId === this.userInfo.id
      ) {
        flag = true;
      } else if (this.userInfo.type === "FINAL_REDACT" && this.data.status !== "UP") {
        flag = true;
      }
      return flag;
    },
    // 关联上课班级
    associateClassBtnFlag() {
      let roles = ["TEACHER", "TEACHER_RESEARCH","SCHOOL_MANAGER"];
      return roles.includes(this.userInfo.type) && !this.data.classCode;
    },
    // 复制课程
    copyCourseFlag() {
      let roles = ["TEACHER","TEACHER_RESEARCH", "SCHOOL_MANAGER"];
      return roles.includes(this.userInfo.type);
    },
    // 编辑课程权限
    editCourseFlag() {
      let flag = false;
      // 老师跟校管
      if (
        ["TEACHER", "TEACHER_RESEARCH","SCHOOL_MANAGER"].includes(this.userInfo.type) &&
        this.data.createUserId === this.userInfo.id &&
        (this.data.status === "CREATING" || this.data.status === "DOWN")
      ) {
        flag = true;
      } else if (
        // 编辑老师
        (this.data.checkStatus === "FINAL_REFUSE" ||
          this.data.checkStatus === "REVIEW_REFUSE" ||
          this.data.checkStatus === "INITIAL") &&
        this.userInfo.type === "REDACT" &&
        (this.data.status === "DOWN" || this.data.status === "CREATING") &&
        this.data.createUserId === this.userInfo.id
      ) {
        flag = true;
      } else if (
        // 审核编辑
        this.data.checkStatus === "WAIT_REVIEW" &&
        this.userInfo.type === "REVIEW_REDACT"
      ) {
        flag = true;
      } else if (
        // 审核编辑
        this.data.checkStatus === "WAIT_FINAL_REVIEW" &&
        this.userInfo.type === "FINAL_REDACT"
      ) {
        flag = true;
      }
      return flag;
    },
    cover() {
      let img;
      if (this.data.cover) {
        img = this.data.cover.includes("cover_") ? this.courseCoverList[this.data.cover] : this.data.cover;
      } else {
        img = this.courseCoverList["cover_3"];
      }
      return img;
    },
    // resImage() {
    //   let type = this.type === "1" ? "1" : "0";
    //   return this.imgDict[type];
    // },
  },
  filters: {
    formatDate(val) {
      return utils.formatDate(val || 0, "yyyy-MM-dd");
    },
  },
  methods: {
    ...mapMutations({
      setCourseActiveId: "onlinecourses/setCourseActiveId",
    }),
    bindClassCodeChange() {
      if (!this.bindClassCode.length) {
        this.$message.error("请选择需要关联的班级");
        return false;
      }
      this.$ajaxJson
        .post(publicUrl.associateClass, {
          bookId: this.data.id,
          ids: this.bindClassCode,
        })
        .then((res) => {
          this.$ajaxCheck(res);
          this.associateClassFlag = false;
          this.$message.success("关联成功");
          this.$emit("update");
        })
        .catch((err) => {
          this.$ajaxError(err);
        });
    },
    getClassList() {
      let _this = this;
      // 查询年级班级列表
      this.$ajax
        .get(publicUrl.addStudentClassList)
        .then((res) => {
          let data = this.$ajaxCheck(res);
          function deepFn(arr) {
            arr &&
              arr.forEach((item) => {
                if (item.classes) {
                  deepFn(item.classes);
                } else {
                  _this.classList.push(item);
                }
              });
          }

          deepFn(data);
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    // 关联上课班级
    associateClassChange() {
      this.getClassList();
      this.associateClassFlag = true;
    },
    gotoCatalogue() {
      this.$emit("updateSession");
      this.setCourseActiveId(this.data.id);
      this.$router.push({
        name: "onlinecourses-catalogue-editable",
        query: {
          id: this.data.id,
          status: "look",
        },
      });
    },
    gotoEdit() {
      this.setCourseActiveId(this.data.id);
      this.$router.push({
        name: "onlinecourses-catalogue-editable",
        query: {
          id: this.data.id,
          status: "edit",
        },
      });
    },
    deleteCourse() {
      this.loadingCount++;
      this.$ajaxJson
        .post(publicUrl.bookDelete, {
          id: this.data.id,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$notify({
              position: "top-left",
              title: "成功",
              message: "删除成功",
              type: "success",
            });

            this.$emit("update");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    copy() {
      this.loadingCount++;
      this.$ajaxJson
        .post(publicUrl.bookCopy, {
          id: this.data.id,
        })
        .then((res) => {
          this.$ajaxCheck(res);
          this.$notify({
            position: "top-left",
            title: "成功",
            message: "复制成功",
            type: "success",
          });
          this.$emit("update");
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    associateClass() {},

    // 上架下架
    courseUpOrDownChange() {
      if (!this.data.classCode) {
        // 草稿状态，该课程还未关联班级，得先关联班级在上架
        this.$notify({
          title: "提示",
          position: "top-left",
          message: "该课本还未关联班级，不能上架",
          type: "error",
        });
        return false;
      }
      this.$ajaxJson
        .post(publicUrl.courseUpOrDown, {
          id: this.data.id,
        })
        .then((res) => {
          this.$ajaxCheck(res);
          this.$emit("update");
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {});
    },
    bookUpAndDownStep1() {
      if (this.data.status === "UP") {
        this.courseType = this.data.type;
        this.bookUpAndDownStep2();
      } else {
        this.courseType = ["CLASS", "SCHOOL"].includes(this.data.type) ? this.data.type : "CLASS";
        this.dialogVisible = true;
      }
    },
    bookUpAndDownStep2() {
      this.loadingCount++;
      this.$ajaxJson
        .post(publicUrl.bookUpAndDown, {
          id: this.data.id,
          type: this.courseType,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.dialogVisible = false;
            this.$notify({
              position: "top-left",
              title: "成功",
              message: "操作成功",
              type: "success",
            });
            this.$emit("update");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    // loadFile(filename) {
    // return require(`../../assets/images/home/${filename}.png`);
    // },
  },
};
</script>

<style scoped lang="less">
@import "@/assets/styles/public.less";
.school_course_item {
  width: 276px;
  background: #f3f8fb;
  border-radius: 20px;
  margin: 15px 0;
  position: relative;
  cursor: pointer;
  .operate {
    position: absolute;
    right: 10px;
    bottom: 10px;
    color: #19a4ff;
    .flex_center;
    .icon {
      font-size: 20px;
    }
    &:hover {
      ul {
        display: block;
      }
    }

    ul {
      width: 104px;
      position: absolute;
      top: 0;
      z-index: 999;
      background: #19a4ff;
      border-radius: 3px;
      display: none;

      li {
        font-size: 14px;
        font-family: SourceHanSansCN-Light, SourceHanSansCN;
        font-weight: 300;
        color: #d1ecff;
        padding: 5px 0;
        cursor: pointer;
        .flex_center;
        &:hover {
          color: #fff;
          background: #5fc0ff;
        }
      }
    }
  }
  .school_course_item_hover {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    border-radius: 18px;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    opacity: 0;
    transition: all 0.2s ease-in-out;
    .footer {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 100px;
      padding: 5px 20px;
      border-top: 1px dashed #fff;
      width: 100%;
      > li {
        .flex_align_items;
        margin: 5px 0;
        .icon {
          margin-right: 5px;
        }
        span {
          font-size: 16px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
  &:hover .operate {
    color: #fff;
  }
  &:hover .school_course_item_hover {
    opacity: 1;
    // transform: translateX(0);
  }

  .cover {
    width: 276px;
    height: 150px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    background-repeat: no-repeat;
    background-size: cover;
    .flex_center;
    > div {
      width: 200px;
      height: 100px;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 20px;
      .flex_center;
      text-align: center;
      font-size: 24px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      word-wrap: break-word;
    }
  }
  .title {
    padding: 12px 20px 0 20px;

    font-size: 20px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    .ellipsis;
  }

  .status {
    display: flex;
    padding: 0 15px;
    .status_1 {
      background: #00aaff;
    }
    .status_2 {
      background: #1bc2b1;
    }
    .status_3 {
      background: #ff9e30;
    }
    .status_4 {
      background: #8341e5;
    }
    .status_5 {
      background: #9baeb8;
    }
    .status_6 {
      border: 1px solid #78919f;
      color: #78919f;
    }
    > p {
      width: 48px;
      height: 20px;
      font-size: 12px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      color: #ffffff;
      border-radius: 2px;
      margin: 10px 5px;
      .flex_center;
    }
  }
  .info {
    padding: 0 20px 10px 20px;
    display: flex;
    // justify-content: space-between;
    position: relative;

    > div {
      .flex_align_items;
      margin-right: 30px;
      .icon {
        font-size: 16px;
        color: #19a4ff;
        margin-right: 4px;
        display: block;
      }
      span {
        font-size: 14px;
        font-family: SourceHanSansCN-ExtraLight, SourceHanSansCN;
        font-weight: 200;
        display: block;
        color: #333333;
        vertical-align: middle;
      }
    }
  }
}
.radio-item {
  p {
    color: #9ea7b4;
    line-height: 2;
    text-indent: 24px;
  }
}
</style>
